var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-inline-block ico-cat"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"18","viewBox":"0 0 25.515 18.745"}},[_c('path',{style:(`fill:${_vm.color}; fill-rule:evenodd;`),attrs:{"id":"Path_5203","data-name":"Path 5203","d":"M25.515,8.25,14.291,0H0L25.515,18.745Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }